import React from 'react';

import { Box, Stack } from '@lyearn/ui';

import { emojiStyles } from '../styles';

const MoodEmojiContainer: React.FC<
  React.PropsWithChildren<{ spacing?: number; faceScaleFactor?: number }>
> = (props) => {
  return (
    <Box className={emojiStyles(props.spacing, props.faceScaleFactor)}>
      <Stack className="feedback" direction="row">
        {props.children}
      </Stack>
    </Box>
  );
};

export default MoodEmojiContainer;
